export const TEXTS = {
  REQUEST_REPORT_MODAL_TITLE: 'Запрос досрочного отчета',
  REQUEST_REPORT_MODAL_CONTENT: (rightHodlerTitle: string) =>
    `Вы можете запросить досрочный отчет для ${rightHodlerTitle} по вчерашний день включительно`,
  REQUEST: 'Запросить',
  CLOSE: 'Закрыть',
  REQUEST_REPORT_SUCCESS_NOTIFICATION: 'Подождите! Отчеты будут сформированы в течение нескольких минут',
};
